import React from "react";
import { __BoardFilterFields_DefaultValues } from "./common/Dictionaries";
import { setBoardCalendarFilterConfig } from "./common/Helpers";
import { __OBJECT_STRUCTURE_GetFilter } from "./common/ObjectStructures/sKPI";

const mainContextStructure = {
  username: "",
  sg3LegacyPath: "#",
  clientName: "",
  help: {
    value: false,
    setter: () => {},
  },
  locale: {
    value: 'en',
    setter: () => {},
  },
  exportFunction: () => {},
  setIspageIsHomeLanding: () => {},
  securityProps: null,
  onlyObserver: false,
  kpiModule: {
    boardDataserieDisplayFields: {
      value: __BoardFilterFields_DefaultValues,
      setter: () => {},
    },
    boardCalendarFilterConfig: {
      value: __OBJECT_STRUCTURE_GetFilter,
      setter: () => {},
      setterGlobal: () => setBoardCalendarFilterConfig,
    } 
  },
  privilegeMatrix: {
    matrix: null,
    roles: null,
    actions: null,
    privileges: null,
  } 
}

export default React.createContext(mainContextStructure);